import type { FaireProductEntity } from "../../entity_types/product";

export const p_ku58qrspuu: FaireProductEntity = {
  token: "p_ku58qrspuu",
  type: "product",
  name: "We Made It! Slop Test Kitchen Notepad with Elephant & Piggie",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/2812ea8273d12ca229aa90ef153bb8fbc530b3da5ff21456400d7ac4c7a51e00.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a8e4bf4e534aa6518261b807cf24e507a5080e1741b2b0ccb670f20a9ae2d809.jpeg"
  ],
  priceDollars: 5,
  description: "Whip up creativity (and a little chaos) with Elephant & Piggie! Inspired by Mo Willems’ We Really Like Cooking Slop!: The Elephant & Piggie Cookbook, this Knock Knock Can-Do pad helps kids (and their grownups) track recipes, rate experiments, and celebrate every gloriously goopy culinary adventure. With 40 recipe sheets and 100 stickers, here’s plenty of space to write reviews, draw food doodles, and award your favorite dishes a special sticker! This fun-yet-functional kids recipe pad helps kids track their kitchen experiments, with a little help from Elephant & Piggie! Perfect for parents looking for screen-free activities for kids—and pairs well with We Really Like Cooking Slop!: The Elephant & Piggie Cookbook. 6 x 9 inches, 40 sheets, 100 stickers.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:08.895Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
